import { motion } from "framer-motion";

const MICROSCOPE_IMG =
  "https://images.unsplash.com/photo-1572884267966-02340ebc90ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxsYWJvcmF0b3J5JTIwbWljcm9zY29wZSUyMGRhcmt8ZW58MHx8fHwxNzg2Mzg5Mzc5fDA&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop";

const CHAPTERS = [
  {
    num: "01",
    title: "SYNTHESIS",
    text: "Every compound is synthesized in ISO-certified facilities under cGMP-aligned protocols. Raw amino acids are coupled with solid-phase precision, then lyophilized into stable, research-ready vials.",
  },
  {
    num: "02",
    title: "PURITY",
    text: "Each batch is verified at 99%+ by reversed-phase HPLC and confirmed by mass spectrometry. Nothing ships below standard — batches that fail are destroyed, not discounted.",
    image: MICROSCOPE_IMG,
  },
  {
    num: "03",
    title: "DOCUMENTATION",
    text: "Full certificates of analysis, batch numbers and third-party lab reports accompany every order. Your research deserves a complete paper trail.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="border-t border-white/10 bg-[#050505]">
      <div className="mx-auto max-w-7xl px-6 py-24 md:py-32">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20 font-mono text-[11px] tracking-[0.35em] text-[#00ff72]"
        >
          THE STANDARD — WHY SFH BIOHEALTH
        </motion.p>

        <div className="space-y-24">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
              className="grid grid-cols-1 gap-8 border-t border-white/10 pt-10 md:grid-cols-12"
            >
              <span className="font-mono text-5xl text-[#00ff72] md:col-span-2 md:text-6xl">
                [{c.num}]
              </span>
              <h3 className="font-display text-4xl tracking-tight text-[#F9F6F0] md:col-span-4 md:text-6xl">
                {c.title}
              </h3>
              <div className="md:col-span-5 md:col-start-8">
                <p className="max-w-md text-sm leading-relaxed text-[#A3A3A3]">{c.text}</p>
                {c.image && (
                  <motion.div
                    initial={{ clipPath: "inset(0 100% 0 0)" }}
                    whileInView={{ clipPath: "inset(0 0% 0 0)" }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, delay: 0.2, ease: [0.76, 0, 0.24, 1] }}
                    className="mt-8 overflow-hidden border border-white/10"
                  >
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      className="aspect-[16/9] w-full object-cover grayscale transition-[filter] duration-700 hover:grayscale-0"
                    />
                  </motion.div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
